import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useLanguage } from '../lib/LanguageContext';
import { translations } from '../lib/translations';
const lineVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      delay: i * 0.12,
      ease: [0.25, 0.1, 0.25, 1]
    }
  })
};
export function ProblemSection() {
  const ref = useRef<HTMLElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const {
    lang
  } = useLanguage();
  const t = translations[lang].problem;
  return <section ref={ref} style={{
    backgroundColor: 'var(--white)',
    padding: '10rem 0'
  }} data-id="element-63">
      <div style={{
      maxWidth: '48rem',
      margin: '0 auto',
      padding: '0 2rem'
    }} data-id="element-64">
        {/* Section label */}
        <motion.p initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {
        opacity: 0
      }} transition={{
        duration: 0.6
      }} style={{
        fontFamily: '"IBM Plex Mono", monospace',
        fontSize: '0.75rem',
        letterSpacing: '0.3em',
        textTransform: 'uppercase',
        color: 'var(--grey-500)',
        marginBottom: '4rem'
      }} data-id="element-65">
          {t.label}
        </motion.p>

        {/* Title */}
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.7,
        delay: 0.1
      }} style={{
        fontFamily: '"IBM Plex Sans", sans-serif',
        fontWeight: 900,
        fontSize: 'clamp(2.5rem, 5vw, 3.75rem)',
        lineHeight: 1.1,
        color: 'var(--black)',
        marginBottom: '4rem'
      }} data-id="element-66">
          {t.title1}
          <br data-id="element-67" />
          {t.title2}
        </motion.h2>

        {/* Body statements */}
        <div style={{
        marginBottom: '3rem'
      }} data-id="element-68">
          {t.statements.map((statement, i) => <motion.p key={i} custom={i} variants={lineVariants} initial="hidden" animate={isInView ? 'visible' : 'hidden'} style={{
          fontFamily: '"IBM Plex Sans", sans-serif',
          fontWeight: 300,
          fontSize: 'clamp(1.2rem, 2.5vw, 1.5rem)',
          color: 'var(--grey-700)',
          lineHeight: 1.8,
          margin: 0
        }} data-id="element-69">
              {statement}
            </motion.p>)}
        </div>

        {/* Closing statement */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.7,
        delay: 0.6
      }} style={{
        fontFamily: '"IBM Plex Sans", sans-serif',
        fontWeight: 700,
        fontSize: 'clamp(1.2rem, 2.5vw, 1.5rem)',
        color: 'var(--black)',
        margin: 0
      }} data-id="element-70">
          {t.closing}
        </motion.p>
      </div>
    </section>;
}